import React, { useEffect, useState } from 'react'
import Modal from '../../modal/modal'
import { emmiter } from '../../../helpers/Emmiter'
import Button from '../../ui/button/button'
import Loader from '../../loader/loader'
import Input from '../../ui/input/input'
import usePosition from '../../../hooks/position.hook'

export const BoxCountModal = () => {
  const { updateBoxCount } = usePosition()
  const [modal, setModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [boxCount, setBoxCount] = useState('')


  useEffect(() => {
    emmiter.on('boxCountModal', data => {
      if(!data) return;

      setModal(data)
      setBoxCount(data?.boxCount !== null ? data?.boxCount : '')
    })

    return () => {
      emmiter.off('boxCountModal')
      setModal(false)
      setBoxCount('')
    }
  }, [])

  const onCloseModal = () => {
    // Если модальное окно было открыто с resolve/reject, вызываем reject при закрытии без сохранения
    // Только если модальное окно еще открыто (не было успешного сохранения)
    if (modal?.reject && !isLoading) {
      modal.reject(new Error('Модальное окно закрыто без сохранения'))
    }
    setModal(false)
    setBoxCount('')
  }

  const onSaveBoxCount = async () => {
    try {
      setIsLoading(true)
      const payload = {
        id: modal.id,
        boxCount: Number(boxCount),
      }

      const res = await updateBoxCount(payload)

      // Сохраняем resolve/reject перед очисткой состояния
      const resolve = modal?.resolve
      const reject = modal?.reject
      const getData = modal?.getData
      
      setModal(false)
      setBoxCount('')

      if(!res) {
        reject('updateBoxCount error')
      }
      
      // Вызываем getData если он передан и ждем обновления данных
      if (getData) {
        await getData(true)
      }
      // Вызываем resolve если он передан (для ожидания в onChooseHandler)
      // resolve вызывается после обновления данных, чтобы статус обновился с актуальными данными
      if (resolve) {
        resolve(res)
      }
    } catch(e) {
      console.log('updateBoxCount error:', e)
      // Сохраняем reject перед очисткой состояния
      const reject = modal?.reject
      setModal(false)
      setBoxCount('')
      // Вызываем reject если он передан
      if (reject) {
        reject(e)
      }
    } finally {
      setIsLoading(false)
    }
  }

  const onBoxCountChange = (e) => {
    setBoxCount(e.target.value)
  }


  return (
    <Modal isOpen={!!modal} closeModal={onCloseModal}>
      <div className='w-[90vw] max-w-[76rem] min-h-[10rem] pt-[7rem]'>
        <span className='block text-center text-Regular(48_52) text-Content/Dark mb-[2rem]'>Количество коробок</span>
        {!!modal.title && <div className='text-Regular(14_16) text-center text-Content/Middle px-[3rem]'>
          Укажите необходимое количество коробок для позиции: <div className='mt-[1rem] text-Regular(16_18) text-Content/Dark'>{modal.title}</div>
        </div>
        }
        <div className='p-[3rem]'>
          <div className='py-[5rem] px-[4rem] bg-Dominant/Dop min-h-[15rem] relative'>
              <Input
                type='number'
                onInput={(e) => onBoxCountChange(e)}
                placeholder='Введите количество'
                initial={modal?.boxCount === null ? '' : modal?.boxCount}>
              </Input>
              <div className='flex justify-center mt-[3.8rem]'>
                <Button disabled={!boxCount} name='Сохранить' onPress={onSaveBoxCount}></Button>
              </div>
            {isLoading && <div className={`absolute inset-0 bg-[rgba(114,_112,_112,_0.5)] z-2`}><Loader /></div>}
          </div>
        </div>
      </div>
    </Modal>
  )
}